module.exports = __webpack_public_path__ + "static/img/15.73d34ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/15.png
// module id = 1nwB
// module chunks = 0